import { Header } from '@/widgets/header';
import type { FC, PropsWithChildren } from 'react';
import { GlobalLayout } from './global.layout';

type PublicLayoutProps = PropsWithChildren;

export const PublicLayout: FC<PublicLayoutProps> = ({ children }) => {
  return (
    <GlobalLayout>
      <Header />

      <div className="flex h-full w-full items-center justify-center">
        {children}
      </div>
    </GlobalLayout>
  );
};
